// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eT","newsTag":"eT","dafalut":"eU","qishou":"eV","shangjia":"eW","shehui":"eX","caiwu":"eY","piyao":"eZ","suanfa":"e0","keji":"e1","lingshou":"e2","gongzuo":"e3"};